import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { Box, Button, Typography } from "@mui/material";
import React from "react";

const CartNavigation = ({
  activeStep,
  steps,
  handleBack,
  handleNext,
  totalPrice,
  isCartEmpty,
}) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column-reverse", sm: "row" },
      justifyContent: activeStep !== 0 ? "space-between" : "flex-end",
      alignItems: "center",
      flexGrow: 1,
      gap: 1,
    }}
  >
    {activeStep !== 0 && (
      <Button
        startIcon={<ChevronLeftRoundedIcon />}
        onClick={handleBack}
        variant="outlined"
        sx={{
          width: "100%",
          height: "40px",
          border: "1px solid #686868",
          borderRadius: "5px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexShrink: 0,

          color: "#424242",
        }}
      >
        Tidligere
      </Button>
    )}

    {!isCartEmpty && activeStep === 0 && (
      <Box sx={{ display: "flex", flexDirection: "row", width: "100%" }}>
        <Typography
          variant="contained"
          sx={{
            flex: 1,
            height: "40px",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {totalPrice} DDK
        </Typography>
        <Button
          variant="contained"
          sx={{
            flex: 1,
            height: "40px",
            backgroundColor: "#424242",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
            "&:hover": {
              backgroundColor: "#686868",
            },
          }}
          endIcon={<ChevronRightRoundedIcon />}
          onClick={handleNext}
        >
          Kassen
        </Button>
      </Box>
    )}

    {activeStep !== 0 &&
      activeStep !== 1 &&
      activeStep !== steps.length - 1 && (
        <Button
          variant="contained"
          sx={{
            width: { xs: "100%", sm: "fit-content" },
            height: "40px",
            backgroundColor: "#424242",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,

            "&:hover": {
              backgroundColor: "#686868",
            },
          }}
          endIcon={<ChevronRightRoundedIcon />}
          onClick={handleNext}
        >
          {activeStep === steps.length - 1 ? "Afgiv bestilling" : "Næste"}
        </Button>
      )}
  </Box>
);

export default CartNavigation;
